import React from "react";
import { Formik, Field, Form } from "formik";
import { TextField } from "formik-material-ui";
import { makeStyles } from "@material-ui/core/styles";

import {
  Fab,
} from "@material-ui/core";

import ArrowIcon from "@material-ui/icons/ArrowUpward";
import { firebase } from "~/src/api";

import { Flex } from "~/src/components/global";

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
  },
}));

export default function MessageInput(props) {
  const { chat, authUser, otherName } = props;
  const { self } = chat;

  const classes = useStyles();

  let placeholder = `Write to ${otherName}`;
  if (authUser.teacher && authUser.studio) {
    placeholder += ` as ${self.type === "teacher" ? self.firstname : self.name}…`;
  } else {
    placeholder += "…";
  }

  return (
      <Formik
        initialValues={{
          message: "",
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          firebase.messages(chat.id).doc().set({
            text: values.message,
            author: self.id,
            type: "text",
            timestamp: firebase.fieldValue.serverTimestamp(),
          })
            .then(() => {
              setSubmitting(false);
              resetForm();
            });
        }}
      >
        {({ isSubmitting, values }) => (
          <Form>
            <Flex align="start">
              <Flex.Item fill>
                <Field
                  name="message"
                  component={TextField}
                  multiline
                  placeholder={placeholder}
                  autoFocus
                  data-cy="message-input"
                />
              </Flex.Item>
              <div className={classes.button}>
                <Fab
                  color="primary"
                  aria-label="send"
                  disabled={isSubmitting || !values.message}
                  type="submit"
                  data-cy="message-send"
                >
                  <ArrowIcon />
                </Fab>
              </div>
            </Flex>
          </Form>
        )}
      </Formik>
  );
}
